module.exports = __webpack_public_path__ + "media/images/icons/group-5690f2f770440a79fabf8bbdf12dbbc0.svg";